// extracted by mini-css-extract-plugin
export default {"molds":"Molds_molds__qyWWi","about":"Molds_about__J54bR","arrow":"Molds_arrow__8MGEN"};